var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRoundFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 28C49 39.598 39.598 49 28 49C16.402 49 7 39.598 7 28C7 16.402 16.402 7 28 7C39.598 7 49 16.402 49 28ZM17.7828 38.2172C17.2946 37.7291 17.2946 36.9376 17.7828 36.4495L26.2322 28L17.7828 19.5505C17.2946 19.0624 17.2946 18.2709 17.7828 17.7828C18.2709 17.2946 19.0624 17.2946 19.5505 17.7828L28 26.2322L36.4495 17.7828C36.9376 17.2946 37.7291 17.2946 38.2172 17.7828C38.7054 18.2709 38.7054 19.0624 38.2172 19.5506L29.7678 28L38.2172 36.4495C38.7054 36.9376 38.7054 37.7291 38.2172 38.2172C37.7291 38.7054 36.9376 38.7054 36.4495 38.2172L28 29.7678L19.5506 38.2172C19.0624 38.7054 18.2709 38.7054 17.7828 38.2172Z",
    fill: "#E44E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundFill);
export default __webpack_public_path__ + "static/media/Close_round_fill.c880a29dda166d9ea0c06dda742090a3.svg";
export { ForwardRef as ReactComponent };